<header class="navbar header-area" *ngIf="auth.loggedIn">
    <!-- Floating the menu toggle button with Font Awesome icons -->
    <a (click)="auth.navOpen = !auth.navOpen" class="menu-toggle-button" [class.open]="auth.navOpen" [matTooltip]="auth.navOpen ? 'Collapse Menu' : 'Expand Menu'">
        <!-- Show fa-angle-left when expanded and fa-bars when minimized -->
        <i class="fas" [ngClass]="auth.navOpen ? 'fa-bars' : 'fa-bars'"></i>
    </a>

    <section class="navbar-section">
        <div class="height70">
            <div class="height70">
                <img id="logoImg" src="/logos/4tm.svg"
                     alt="4Comply" />
            </div>
        </div>
    </section>

    <section class="navbar-section" *ngIf="auth.userProfile$ | async as profile">
        <div class="header-actions">
            <!-- Ghost tenant switcher (left of language flag) -->
            <button type="button"
                    class="tenant-ghost-btn"
                    [matMenuTriggerFor]="tenantMenu"
                    [matTooltip]="'HEADER.COMPANY_SELECTOR' | translate"
                    [attr.aria-label]="'HEADER.COMPANY_SELECTOR' | translate">
                <span class="tenant-name">{{ getTenantPrimary(profile.currentTenant) }}</span>
                <i class="fas fa-chevron-down tenant-chevron"></i>
            </button>
            <mat-menu #tenantMenu="matMenu" xPosition="before" [class]="'header-ghost-menu tenant-menu'">
                <button mat-menu-item
                        *ngFor="let tenant of profile.tenants; trackBy: trackByTenantId"
                        (click)="changeTenant([tenant])"
                        [class.is-active]="tenant === profile.currentTenant">
                    <span class="menu-label">
                        <span class="tenant-name">{{ getTenantPrimary(tenant) }}</span>
                    </span>
                    <i *ngIf="tenant === profile.currentTenant" class="fas fa-check menu-check"></i>
                </button>
                <button mat-menu-item class="tenant-add" (click)="changeTenant('0000000000')">
                    <i class="fas fa-plus menu-flag"></i>
                    <span class="menu-label">{{ "HEADER.ADD_COMPANY" | translate }}</span>
                </button>
            </mat-menu>

            <!-- Borderless flag-only language switcher (left of settings gear) -->
            <button type="button"
                    class="lang-flag-btn"
                    [matMenuTriggerFor]="langMenu"
                    [matTooltip]="'HEADER.LANGUAGE_SELECTOR' | translate"
                    [attr.aria-label]="'HEADER.LANGUAGE_SELECTOR' | translate">
                <img class="lang-flag-img" [src]="selectLangImage" [alt]="selectLangLabel" />
                <i class="fas fa-chevron-down lang-chevron"></i>
            </button>
            <mat-menu #langMenu="matMenu" xPosition="before" [class]="'header-ghost-menu'">
                <button mat-menu-item
                        *ngFor="let lang of TransLang; trackBy: trackByLangValue"
                        (click)="setTransLanguageDirect(lang.value)"
                        [class.is-active]="lang.value === selectLang">
                    <img class="lang-flag-img menu-flag" [src]="lang.image" [alt]="lang.label" />
                    <span class="menu-label">{{ lang.label }}</span>
                    <i *ngIf="lang.value === selectLang" class="fas fa-check menu-check"></i>
                </button>
            </mat-menu>

            <a [routerLink]="'/settings'"
               class="btn btn-link"
               [matTooltip]="'BASIC_ENTITIES_PLURAL.SETTINGS' | translate">
                <i class="fas fa-cog"></i>
            </a>
            <!-- The bell sits where the documentation icon used to, next to the gear: it is the
                 icon in this bar people reach for, and documentation moved into the account menu. -->
            <app-notification-bell></app-notification-bell>

            <!-- Account menu: identity, role, change password and logout.
                 The email address is deliberately not rendered in the bar - it lives inside
                 the panel, so it is not on screen on every page of the product. -->
            <button type="button"
                    class="user-menu-btn"
                    [matMenuTriggerFor]="userMenu"
                    [matTooltip]="'HEADER.ACCOUNT_MENU' | translate"
                    [attr.aria-label]="'HEADER.ACCOUNT_MENU' | translate">
                <span class="um-initials">{{ getInitials(profile) }}</span>
                <span class="um-name">{{ getDisplayName(profile) }}</span>
                <i class="fas fa-chevron-down um-chevron"></i>
            </button>
            <mat-menu #userMenu="matMenu" xPosition="before" [class]="'header-ghost-menu user-menu'">
                <div class="um-head">
                    <span class="um-initials lg">{{ getInitials(profile) }}</span>
                    <div class="um-id">
                        <div class="um-full">{{ getDisplayName(profile) }}</div>
                        <div class="um-email">{{ profile.email }}</div>
                        <span class="um-role" *ngIf="getRoleLabel(profile) as roleLabel">
                            {{ roleLabel | translate }}
                        </span>
                    </div>
                </div>
                <!-- A BUTTON, like the two items below it, not an anchor. As an <a> this row
                     drew a rule above and below itself: the panel's item styling was written for
                     `button.mat-mdc-menu-item` (see the `border: 0` and the focus-ring remarks in
                     header.component.scss) and an anchor picked up a different box. Matching the
                     siblings is worth more here than an anchor's middle-click, on a link that goes
                     to one fixed external page. `openDocs()` supplies the noopener the bar's old
                     anchor was missing. -->
                <button mat-menu-item (click)="openDocs()">
                    <i class="fas fa-book um-item-icon" aria-hidden="true"></i>
                    <span class="menu-label">{{ "BASIC_ENTITIES_SINGULAR.DOCUMENTATION" | translate }}</span>
                </button>
                <button mat-menu-item (click)="openPasswordModal()">
                    <i class="fas fa-key um-item-icon" aria-hidden="true"></i>
                    <span class="menu-label">{{ "USER.CHANGE_PASSWORD" | translate }}</span>
                </button>
                <button mat-menu-item (click)="logout()">
                    <i class="fas fa-sign-out-alt um-item-icon" aria-hidden="true"></i>
                    <span class="menu-label">{{ "GENERIC.LOGOUT" | translate }}</span>
                </button>
            </mat-menu>
        </div>
    </section>
</header>

<app-modal (closer)="closeModal()" #modalClient title="HEADER.ADD_COMPANY">
    <app-form #formClient
              [fields]="fieldsFormFields"
              [model]="modelFormFields"
              [callback]="submitFormFields">
    </app-form>
</app-modal>

<!-- Change password. Uses the shared app-modal, like Systems and Business Units, so the chrome,
     sizing and close behaviour are the product's standard rather than this screen's own.
     Asks for the new value twice and nothing else: by product decision the current password is
     not required, so a live session is enough to change it. -->
<app-modal #modalPassword
           title="USER.CHANGE_PASSWORD"
           size="small"
           (closer)="onPasswordModalClosed()">
  <div class="pw-modal-content">
    <div class="pw-field">
      <label class="pw-field-label" for="pw-new">
        {{ "USER.NEW_PASSWORD" | translate }} <span class="req">*</span>
      </label>
      <input id="pw-new"
             class="pw-input"
             type="password"
             name="newPassword"
             autocomplete="new-password"
             [(ngModel)]="newPassword" />
    </div>

    <div class="pw-field" [class.invalid]="confirmPassword && !passwordsMatch">
      <label class="pw-field-label" for="pw-confirm">
        {{ "USER.CONFIRM_PASSWORD" | translate }} <span class="req">*</span>
      </label>
      <input id="pw-confirm"
             class="pw-input"
             type="password"
             name="confirmPassword"
             autocomplete="new-password"
             [(ngModel)]="confirmPassword" />
      <div class="pw-field-error" *ngIf="confirmPassword && !passwordsMatch">
        {{ "USER.PASSWORDS_DO_NOT_MATCH" | translate }}
      </div>
    </div>

    <!-- The tenant's real Auth0 rules, ticked live. Absent when they could not be read:
         Auth0 still enforces them, the dialog just cannot state them. -->
    <ul class="pw-rules" *ngIf="passwordRules.length">
      <li *ngFor="let rule of passwordRules; trackBy: trackByRuleKey" [class.met]="rule.met">
        <i class="fas" [ngClass]="rule.met ? 'fa-check' : 'fa-circle'" aria-hidden="true"></i>
        <span>{{ rule.key | translate:rule.params }}</span>
      </li>
    </ul>

    <div class="pw-field-error pw-server-error" *ngIf="passwordError">
      {{ passwordError | translate }}
    </div>

    <div class="pw-modal-foot">
      <button type="button" class="pw-btn ghost" (click)="closePasswordModal()">
        {{ "GENERIC.CANCEL" | translate }}
      </button>
      <button type="button"
              class="pw-btn primary"
              [disabled]="!canSubmitPassword"
              (click)="submitPassword()">
        <i class="fas fa-check" aria-hidden="true"></i>
        {{ "GENERIC.SAVE" | translate }}
      </button>
    </div>
  </div>
</app-modal>
